<template>
    <div>
    </div>
</template>
<script>
import axios from 'axios';
  export default {
    name: 'GetSubjectsRecordAxiosBySchool',
    props:[
        'authToken',
        'school',
        'refreshSignal'
    ],
    mounted() {
       this.getRecords()
    },
    data: () => ({
    }),
    watch:{
        refreshSignal(signal){
            console.log(signal)
            this.getRecords()
        }
    },
    methods: {
        getRecords () {
            axios.get(process.env.VUE_APP_BASEURL+'/subjects?school_id='+this.school.school_id,
            {
                headers: 
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.$emit("get_subjects", response.data.data); // Emit the event with data              
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    localStorage.removeItem('authToken')
                }
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
            });
        }
    },
  }
</script>